import { useState } from "react";
import { faqs } from "@/mocks/chaqua";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-white py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-coral-500">
            <i className="ri-question-answer-line" aria-hidden="true"></i>FAQ
          </span>
          <h2 className="mt-2 text-2xl font-black text-stone-900 md:text-3xl">关于吃瓜在线的常见问题</h2>
          <p className="mt-3 text-sm text-stone-500">还没吃明白？先看这里，也许你的问题已经有答案了。</p>
        </div>

        <div className="mx-auto max-w-3xl space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition ${
                  isOpen ? "border-coral-200 bg-coral-50/40" : "border-cream-200 bg-cream-50"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          isOpen ? "bg-coral-500 text-white" : "bg-white text-coral-500 ring-1 ring-inset ring-cream-200"
                        }`}
                      >
                        {isOpen ? <i className="ri-subtract-line" aria-hidden="true"></i> : <i className="ri-add-line" aria-hidden="true"></i>}
                      </span>
                      <span className={`text-[15px] font-semibold ${isOpen ? "text-coral-700" : "text-stone-800"}`}>
                        {f.q}
                      </span>
                    </span>
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-stone-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}